import React, { useRef, useEffect, useState } from 'react';
import DataViz from "./pytutor/DataViz";
import {getTraceLayouts} from "../util/TraceUtil";
import StepCtrl from "./pytutor/StepCtrl";

export default ({dat, onStep, breakPoints, lang, onError}) => {
  const [curEntry, setCurEntry] = useState();
  const [curTraceLayout, setCurTraceLayout] = useState();
  const [curInstr, setCurInstr] = useState(0);
  const [traceLayouts, setTraceLayouts] = useState(null);
  const evRef = useRef(null);

  useEffect(() => {
    if (dat) {try {
      if (traceLayouts) {
        setCurTraceLayout(traceLayouts[curInstr])
      } else {
        let newTraceLayouts = getTraceLayouts(dat.trace, lang);
        console.log("newTraceLayouts", newTraceLayouts)
        setTraceLayouts(newTraceLayouts)
        setCurTraceLayout(newTraceLayouts[curInstr])
      }
      let traceElement = dat.trace[curInstr];
      setCurEntry(traceElement)
      onStep && onStep(traceElement.line, [traceElement.stdout, traceElement.exception_msg].filter(item => item).join("\n"), curInstr === dat.trace.length - 1, traceElement.exception_msg)
      //内存可视窗自动滚动
      autoScroll()
    } catch (e) {
      onError && onError(e)
    }
  }}, [curInstr]);

  const autoScroll = () => {
    const container = evRef.current;
    if (!container) return;

    // 获取 id 为 'heap' 的元素
    const heapElement = document.getElementById("heap");
    if (!heapElement || heapElement.children.length === 0) return;

    // 获取 heap 的最后一个子元素
    const lastChild = heapElement.lastElementChild;
    if (!lastChild) return;

    // 获取容器和目标元素的位置信息
    const containerRect = container.getBoundingClientRect();
    // 获取 lastChild 内的第一个 div
    const targetDiv = lastChild.querySelector("div");
    if (!targetDiv) return;

    const targetRect = targetDiv.getBoundingClientRect();

    // 计算滚动的偏移量
    const offsetTop =
      targetRect.top - containerRect.top + container.scrollTop - container.clientHeight / 2 + targetRect.height / 2;
    const offsetLeft =
      targetRect.left - containerRect.left + container.scrollLeft - container.clientWidth / 2 + targetRect.width / 2;

    // 平滑滚动
    container.scrollTo({
      top: Number.MAX_SAFE_INTEGER,
      left: offsetLeft,
      behavior: "smooth"
    });
  };
  return (
    <>
    {curEntry && curTraceLayout &&
      <>
        <div className="ExecutionVisualizer" ref={evRef}>
          <DataViz curEntry={curEntry} curTraceLayout={curTraceLayout} lang={lang}/>
        </div>
        <div id="codAndNav" className="debugSteps">
          <StepCtrl curInstr={curInstr} setCurInstr={setCurInstr} trace={dat.trace} breakPoints={breakPoints}/>
        </div>
      </>
    }
    </>
  )
};
